import React from 'react'
import ProductTypes from '../../components/Home/ProductTypes/ProductTypes'
import FirstBanner from '../../components/Home/FirstBanner/FirstBanner';
import SecondBanner from '../../components/Home/SecondBanner/SecondBanner';
import Service from '../../components/Home/Service/Service';
import ProductTypesBanner from '../../components/Home/ProductTypesBanner/ProductTypesBanner';
import SliderBrand from '../../components/Home/SliderBrand/SliderBrand';
import ThirdBanner from '../../components/Home/ThirdBanner/ThirdBanner';
import FourthBanner from '../../components/Home/FourthBanner/FourthBanner';
import PopularProducts from '../../components/Home/PopularProducts/PopularProducts';
import SpecialSaleProducts from '../../components/Home/SpecialSaleProducts/SpecialSaleProducts';
import BestSellingProducts from '../../components/Home/BestSellingProducts/BestSellingProducts';
import SpecialOffer from '../../components/Home/SpecialOffer/SpecialOffer';
import LatestProducts from '../../components/Home/LatestProducts/LatestProducts';


function Home() {
    return (
        <>
            <main>
                <FirstBanner />
                {/* <SecondBanner /> */}
                <PopularProducts />
                <ThirdBanner />
                <SpecialOffer />
                <FourthBanner />
                <SpecialSaleProducts />
                <Service />
                <ProductTypes />
                <BestSellingProducts />
                <ProductTypesBanner />
                <LatestProducts />
                <SliderBrand />
            </main>
        </>
    )
}
export default Home
